@if (product() === clearing) {
	<!-- todo: change style to be secondary-button -->
	<uc-clearing-visit-website-btn
		[customStyles]="customStyles()"
		[externalUrl]="externalUrl()"
		[componentName]="componentName()"
		[uniId]="uniId()"
		[buttonText]="buttonText()"
		[source]="uniName()"
		[componentName]="componentName()"
		sourceType="uni"
		[cleSearchOrderPosition]="searchOrderPosition()"
		[uniName]="uniName()"
		[privacyPolicyUrl]="privacyPolicyUrl()"
	/>
} @else {
	<uc-visit-website-btn
		[customStyles]="customStyles()"
		[externalUrl]="externalUrl()"
		[product]="product()"
		[componentName]="componentName()"
		[uniId]="uniId()"
		[buttonText]="buttonText()"
		[source]="uniName()"
		[componentName]="componentName()"
		sourceType="uni"
		[product]="product()"
		[ugSearchOrderPosition]="searchOrderPosition()"
		[uniName]="uniName()"
	/>
}
